module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hero_768.ba6e7a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/fullscreen-image_hero_768.png
// module id = 24Lo
// module chunks = 0